export default __webpack_public_path__ + "static/brandon-regular-1f4a397fc3152aa65d9e93169c2caaaa.woff";